import { render, staticRenderFns } from "./IpPolicy.vue?vue&type=template&id=e5b659de&scoped=true"
import script from "./IpPolicy.vue?vue&type=script&lang=ts"
export * from "./IpPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b659de",
  null
  
)

export default component.exports